<template>
  <b-container>
    <b-button
      :to="{
        name: 'Oplevering',
      }"
      class="mb-4"
    >
      Naar nieuwe of openstaande oplevering <font-awesome-icon 
        icon="arrow-right"
      />
    </b-button>
    <b-table 
      :busy="busy"
      :items="opleveringen"
      :caption="unit.UnitKenmerk"
      :fields="['datum','rapport','notes']"
      small 
      bordered
      striped
    >
      <template #cell(datum)="data">
        <span>{{ moment(data.item.datum).format('LLL') }}</span>
      </template>
      <template #cell(rapport)="data">
        <download 
          v-if="data.item.gereed"
          :download-url="`/unit/${$props.unit.Id}/oplevering/${data.item.id}/download`" 
          filename="Oplevering-1.pdf"
        />
        <b-button
          v-else
          :to="{
            name: 'Oplevering',
          }"
          variant="primary"
        >
          Naar oplevering <font-awesome-icon 
            icon="arrow-right"
          />
        </b-button>
      </template>
    </b-table>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import { unitTabMixin } from "@/mixins/unitMixin";
import Download from '../../components/Download.vue';


export default {
  name: "TabOpleveringen",
  components: {
    Download
  },
  mixins: [serviceMixin, unitTabMixin],
  props: {},
  data() {
    return  {
            opleveringen: [],
            busy: false
        }
  },
  computed: {
    opleverUrl: function () {
        return "/unit/" + this.$props.unit.Id + "/opleveringen";
      },
  },
  watch: {},
  mounted () {
        this.getOpleveringen()
    },
  methods: {
    getOpleveringen() {
        var vm = this;
        vm.busy=true;
        this.get(this.opleverUrl)
        .then(function (response) {
          console.dir(response.data);
          vm.opleveringen = response.data.opleveringen;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => vm.busy = false);
      },
      downloadOplevering(id) {
        console.log(  "downloadOplevering: " + id);
      }
  },
};

</script>